import { render, staticRenderFns } from "./ManagementTable.vue?vue&type=template&id=214cc15a&scoped=true&"
import script from "./ManagementTable.vue?vue&type=script&lang=ts&"
export * from "./ManagementTable.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementTable.vue?vue&type=style&index=0&id=214cc15a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214cc15a",
  null
  
)

export default component.exports